import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {  Dialog,  Box,  IconButton,  List,  ListItem,  ListItemButton,  ListItemText, ListItemIcon } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { House, Calendar, User, Stethoscope, Settings } from "lucide-react";

const menuItems = [
    { text: 'Início', path: '/home', icon: <House size={24} /> },
    { text: 'Agenda', path: '/agenda', icon: <Calendar size={24} /> },
    { text: 'Paciente', path: '/patient-list', icon: <User size={24} /> },
    { text: 'Dentista', path: '/dentist', icon: <Stethoscope size={24} /> },
    { text: 'Configurações', path: '/print-settings', icon: <Settings size={24} /> }, 
];

export default function SidebarMobile({ open, onClose }) {
    const navigate = useNavigate();
    const location = useLocation(); 

    const navigateItems = (path) => {
        navigate(path); 
        onClose();      
    };

    return (
        <Dialog
            fullScreen
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    margin: 0, 
                    borderRadius: 0, 
                    maxHeight: '100%', 
                    height: '100%', 
                }
            }}
        >
            <Box
                sx={{
                    backgroundColor: 'white', 
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',     
                    justifyContent: 'center', 
                    position: 'relative',
                }}
            >
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        top: 16,
                        right: 16,
                        color: '#424242', 
                    }}
                >
                    <CloseIcon fontSize="large" />
                </IconButton>

                <List sx={{ width: 'auto' }}>
                    {menuItems.map((item) => {
                        
                        const isActive = location.pathname === item.path;
                        
                        return (
                            <ListItem key={item.text} disablePadding sx={{ padding: '4px 0' }}> 
                                <ListItemButton 
                                    onClick={() => navigateItems(item.path)} 
                                    sx={{ 
                                        borderRadius: '8px', 
                                        padding: '12px 16px',
                                        minWidth: '250px', 
                                        backgroundColor: isActive ? '#0d6efd' : 'transparent',
                                        color: isActive ? 'white' : '#212529',
                                        '&:hover': {
                                            backgroundColor: isActive ? '#0b5ed7' : '#f8f9fa'
                                        }
                                    }}
                                >
                                    <ListItemIcon 
                                        sx={{ 
                                            color: 'inherit', 
                                            minWidth: '48px' 
                                        }}
                                    >
                                        {item.icon}
                                    </ListItemIcon>
                                    
                                    <ListItemText 
                                        primary={item.text} 
                                        primaryTypographyProps={{
                                            fontSize: '1.1rem', 
                                            fontWeight: isActive ? 600 : 400,
                                        }}
                                        sx={{ textAlign: 'center' }}
                                    />

                                </ListItemButton>
                            </ListItem>
                        );
                    })}
                </List>
            </Box>
        </Dialog>
    );
}